'use strict';

function showErrorModal(errorCode, callback) {

	var text;

	switch(errorCode){
		// Unauthorized
		case 503:
			text = 'Der Server ist aufgrund einer temporären Überlastung oder Wartung nicht erreichbar.';
			break;
		// Unauthorized
		case 401:
			text = 'Ihre Sitzung ist abgelaufen. Sie müssen sich erneut einloggen.';
			break;
		// Forbidden
		case 403:
			text = 'Leider sind Ihre Berechtigungen nicht ausreichend. Bitte melden Sie sich erneut an und versuchen Sie es noch einmal.';
			break;
		default:
			// nur die gelisteten Fehlertypen hier behandeln (vorerst) -> Man könnte hier auch zentral Application-Errors abfangen
			return;
	}

	$('body').append('<div class="modal fade" id="errorModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false"> \
			<div class="modal-dialog"> \
				<div class="modal-content" style="width:600px; margin-left: auto; margin-right:auto; "> \
					<div class="modal-header">\
						<h3>Ein Fehler ist aufgetreten</h3>\
					</div>\
					<div class="modal-body"> \
						<div class="alert alert-warning">' + text + '</div>\
					</div> \
					<div class="modal-footer"> \
						<button type="button" class="btn btn-primary" id="toLoginBtn">Zum Login</button> \
					</div> \
				</div> \
			</div> \
		</div>'
	);
	$('#errorModal').modal({
		backdrop: 'static',
		keyboard: false
	});

	$('#toLoginBtn').click(function(){
		window.location.href = BASE_PATH + 'auth/logout';
	});

	if (callback && typeof callback === 'function') {
        callback();
    }

	return true;
}

$(document).ajaxError(function(event, jqxhr, settings, exception) {

	showErrorModal(jqxhr.status);

});